import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M9.987 6.732V3.7a1 1 0 0 1 1-1H19.5a1 1 0 0 1 1 1v18.08"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M14.013 21.78V7.805a1 1 0 0 0-1-1H4.5a1 1 0 0 0-1 1V21.78M7.084 11.153v1.593M7.084 15.45v1.593M10.429 11.153v1.593M16.916 11.153v1.593M16.916 6.076V7.67"
    />
  </svg>
);
export const CompanyIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
